import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icons } from '@ohif/ui-next';
import ErrorScreen from './ErrorScreen';

const NotFoundServer = ({ message }) => {
  const { t } = useTranslation('NotFound');
  const resolvedMessage =
    message ??
    t(
      'Unable to query for studies at this time. Check your data source configuration or network connection'
    );

  return (
    <ErrorScreen
      illustration={<Icons.StatusWarning className="h-16 w-16" />}
      title={t('Connection problem')}
    >
      <p>{resolvedMessage}</p>
    </ErrorScreen>
  );
};

NotFoundServer.propTypes = {
  message: PropTypes.string,
};

export default NotFoundServer;
